import React from "react";
import '../../../styles/ProductCreateForm.css';


function FieldError(props) {
  return <p className="error-message">⛔ {props.errorMessage}</p>
}
export default FieldError;